import { type Enum } from '@webapp/infrastructure/types/Enum'

export const RequestTypes = {
  FUND: 'fund',
  FUND_TOPUP: 'fund topup',
  VIRTUAL_CARD: 'virtual card',
  VIRTUAL_CARD_TOPUP: 'virtual card topup',
} as const

export type RequestTypeEnum = Enum<typeof RequestTypes>
